// extracted by mini-css-extract-plugin
module.exports = {"container":"message_container__3PPIJ","noMessage":"message_noMessage__1m2MN","topInner":"message_topInner__2nnQD","message":"message_message__3bdj6"};